"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var guard_exports = {};
__export(guard_exports, {
  isGeometry: () => isGeometry,
  isGeometryAtom: () => isGeometryAtom,
  isGeometryAtomType: () => isGeometryAtomType,
  isGeometryCollection: () => isGeometryCollection,
  isGeometryType: () => isGeometryType,
  isLineString: () => isLineString,
  isMultiLineString: () => isMultiLineString,
  isMultiPoint: () => isMultiPoint,
  isMultiPolygon: () => isMultiPolygon,
  isPoint: () => isPoint,
  isPolygon: () => isPolygon
});
module.exports = __toCommonJS(guard_exports);
var import_position = require("../position/index.js");
function isPoint(v) {
  return typeof v === "object" && v != null && "type" in v && v.type === "Point" && "coordinates" in v && (0, import_position.isPosition)(v.coordinates);
}
function isMultiPoint(v) {
  return typeof v === "object" && v != null && "type" in v && v.type === "MultiPoint" && "coordinates" in v && Array.isArray(v.coordinates) && v.coordinates.every(import_position.isPosition);
}
function isLineString(v) {
  return typeof v === "object" && v != null && "type" in v && v.type === "LineString" && "coordinates" in v && Array.isArray(v.coordinates) && v.coordinates.every(import_position.isPosition);
}
function isMultiLineString(v) {
  return typeof v === "object" && v != null && "type" in v && v.type === "MultiLineString" && "coordinates" in v && Array.isArray(v.coordinates) && v.coordinates.every((i) => Array.isArray(i) && i.every(import_position.isPosition));
}
function isPolygon(v) {
  return typeof v === "object" && v != null && "type" in v && v.type === "Polygon" && "coordinates" in v && Array.isArray(v.coordinates) && v.coordinates.every((i) => Array.isArray(i) && i.every(import_position.isPosition));
}
function isMultiPolygon(v) {
  return typeof v === "object" && v != null && "type" in v && v.type === "MultiPolygon" && "coordinates" in v && Array.isArray(v.coordinates) && v.coordinates.every(
    (i) => Array.isArray(i) && i.every((i2) => Array.isArray(i2) && i2.every(import_position.isPosition))
  );
}
function isGeometryCollection(v) {
  return typeof v === "object" && v != null && "type" in v && v.type === "MultiPolygon" && "geometries" in v && Array.isArray(v.geometries) && v.geometries.every(isGeometry);
}
function isGeometryAtom(v) {
  return (0, import_position.isPosition)(v) || isPoint(v) || isMultiPoint(v) || isLineString(v) || isMultiLineString(v) || isPolygon(v) || isMultiPolygon(v);
}
function isGeometry(v) {
  return isGeometryAtom(v) || isGeometryCollection(v);
}
function isGeometryAtomType(v) {
  switch (v) {
    case "Point":
      return true;
    case "MultiPoint":
      return true;
    case "LineString":
      return true;
    case "MultiLineString":
      return true;
    case "Polygon":
      return true;
    case "MultiPolygon":
      return true;
    default:
      return false;
  }
}
function isGeometryType(v) {
  return isGeometryAtomType(v) || v === "GeometryCollection";
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isGeometry,
  isGeometryAtom,
  isGeometryAtomType,
  isGeometryCollection,
  isGeometryType,
  isLineString,
  isMultiLineString,
  isMultiPoint,
  isMultiPolygon,
  isPoint,
  isPolygon
});
//# sourceMappingURL=guard.js.map
